import React from 'react'

import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useModalData } from '../../../components/modals/ModalsContext'
import LineSeparator from '../../../packages/kiti/components/helpers/LineSeparator'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const { ids } = useModalData() || {}
  const title = `Gerando ${ids?.length > 1 ? 'QR Codes' : 'QR Code'}`

  return (
    <>
      <Title size="h5" bold>
        {title}
      </Title>
      <LineSeparator weight={2} />
      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
